/**
 * The single ordering + palette for document status, shared by the "Status"
 * filter and the stats banner at the top of Data.
 *
 * UI-26 (Pegah): "For success, processing, failed, use the same color, and
 * order in 'Status' and in the top bar in 'Data'." They had drifted on both
 * counts — the banner read success/processing/failed with `-600` icons while
 * the filter read processing/success/failed with `-500` dots, and processing
 * was orange in one and yellow in the other. Both now read this list, so the
 * next change to either lands in both.
 */
export interface StatusMeta {
  /** DocumentStatus enum key, as the filter and the server use it. */
  value: 'success' | 'processing' | 'failed'
  /** i18n key — the same label the banner and the filter both show. */
  labelKey: string
  /** Dot swatch in the filter menu. */
  dotClass: string
  /** Icon tint in the banner. */
  iconClass: string
  /** Icon plate behind that tint in the banner. */
  iconBg: string
}

export const STATUS_META: readonly StatusMeta[] = [
  {
    value: 'success',
    labelKey: 'data_catalog:stats.success',
    dotClass: 'bg-green-600',
    iconClass: 'text-green-600',
    iconBg: 'bg-[#dcfce7]',
  },
  {
    value: 'processing',
    labelKey: 'data_catalog:stats.processing',
    dotClass: 'bg-orange-600',
    iconClass: 'text-orange-600',
    iconBg: 'bg-[#ffedd5]',
  },
  {
    value: 'failed',
    labelKey: 'data_catalog:stats.failed',
    dotClass: 'bg-red-600',
    iconClass: 'text-red-600',
    iconBg: 'bg-[#fef2f2]',
  },
] as const
